import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { QuoteTrackingService } from '../../quote-tracking.service'
import { Observable } from 'rxjs'
import { LaunchDialogService } from '@spartacus/storefront'
import { Actions, ofType } from '@ngrx/effects'
import {
  GlobalMessageType,
  GlobalMessageService,
  TranslationService,
} from '@spartacus/core'
import { DeliveryAddress } from '../../../quote-checkout/model/address-models'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { filter, take } from 'rxjs/operators'
import { MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import {
  CurrentQuoteStatus,
  QuoteStatus,
} from '../../../../../models/status/status.model'
import { BreadcrumbService } from '../../../../../shared/components/breadcrumb/breadcrumb.service'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-merge-quote-acceptance',
  templateUrl: './merge-quote-acceptance.component.html',
  styleUrls: ['./merge-quote-acceptance.component.scss'],
})
export class MergeQuoteAcceptanceComponent implements OnInit {
  quoteId: any
  quoteAcceptanceType: any
  quoteDetails$: Observable<any>
  quoteDetailsData: any
  userType = 'current'
  lineItems = []
  newCartId: any
  shipToAddress: DeliveryAddress
  billToAddress: DeliveryAddress
  endUserAddress: DeliveryAddress
  status = true
  QuoteStatus = QuoteStatus
  public loader = false
  CurrentQuoteStatus = CurrentQuoteStatus
  AcceptQuote$: Observable<any>
  dateObject: any
  myQuotesLabel
  quoteDetailsLabel
  constructor(
    public breadCrumbService: BreadcrumbService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public quoteTrackingService: QuoteTrackingService,
    private launchDialogService: LaunchDialogService,
    private actions$: Actions,
    private quoteCartService: QuoteCartService,
    private multiCartService: MultiCartFacade,
    private translate: TranslationService,
    private globalMessageService: GlobalMessageService
  ) {}
  acceptance = true
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dateObject = params
      this.quoteAcceptanceType = params['status']
    })
    this.activatedRoute.params.subscribe((value) => {
      this.quoteId = value['quoteId']
      this.quoteDetails$ = this.quoteTrackingService.getQuoteDetailsFromList(
        this.quoteId,
        this.dateObject.fromDate,
        this.dateObject.toDate
      )
      this.quoteDetails$.subscribe((success) => {
        this.quoteDetailsData = success
        this.quoteDetailsData?.quoteLineDetails.forEach((element) => {
          if (element.quoteStatusCode !== CurrentQuoteStatus.OPEN) {
            this.status = false
          }
        })

        var ship =
          this.quoteDetailsData.quoteDetailsList.shipToAddress.split(';')

        this.shipToAddress = {
          partnerNumber: ship[0],
          companyName: ship[1],
          line1: ship[3],
          line2: ship[2],
          town: ship[4],
          region: {
            isocode: ship[7] + '-' + ship[6],
          },
          country: {
            isocode: ship[7],
          },
          postalCode: ship[8],
        }
        var sold =
          this.quoteDetailsData.quoteDetailsList.soldToAddress.split(';')

        this.billToAddress = {
          companyName: sold[0],
          line1: sold[2],
          line2: sold[1],
          town: sold[3],
          region: {
            isocode: sold[6] + '-' + sold[5],
          },
          country: {
            isocode: sold[6],
          },
          postalCode: sold[7],
        }
        var end =
          this.quoteDetailsData.quoteDetailsList.endUserAddresss.split(';')

        this.endUserAddress = {
          partnerNumber: end[0],
          companyName: end[1],
          line1: end[3],
          line2: end[2],
          town: end[4],
          region: {
            isocode: end[7] + '-' + end[6],
          },
          country: {
            isocode: end[7],
          },
          postalCode: end[8],
        }
      })
    })

    this.translate
      .translate('quoteTracking.myQuotes')
      .subscribe((res: string) => {
        this.myQuotesLabel = res
      })

    this.translate
      .translate('quoteTracking.quoteDetails')
      .subscribe((res: string) => {
        this.quoteDetailsLabel = res
        let breadcrumb = [
          {
            label: this.myQuotesLabel,
            link: '/quote-list',
          },
          {
            label: this.quoteDetailsLabel,
            link: '/quote-detail/' + this.quoteId,
          },
        ]
        this.breadCrumbService.setBreadCrumbs(breadcrumb)
      })

    if (
      this.quoteAcceptanceType == QuoteStatus.ADDITIONAL.toLocaleLowerCase()
    ) {
      this.translate
        .translate('quoteTracking.additionalPartsQuote')
        .subscribe((res: string) =>
          this.breadCrumbService.setBreadcrumbTitle(res)
        )
    }
    if (this.quoteAcceptanceType == QuoteStatus.ACCEPT.toLocaleLowerCase()) {
      this.translate
        .translate('quoteTracking.acceptRejectQuote')
        .subscribe((res: string) =>
          this.breadCrumbService.setBreadcrumbTitle(res)
        )
    }

    this.quoteTrackingService.rejectOnceEmitted$.subscribe((res) => {
      if (res) {
        this.quoteDetails$ = this.quoteTrackingService.getQuoteDetailsFromList(
          this.quoteId,
          this.dateObject.fromDate,
          this.dateObject.toDate
        )
      }
    })
  }
  navigateToDetails() {
    this.router.navigate(['quote-detail', this.quoteId], {
      queryParams: this.dateObject,
    })
  }
  getFormattedDate(d) {
    var newDate = d.split('-')
    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    var selectedMonthName = months[parseInt(newDate[1]) - 1]
    return newDate[2] + ' ' + selectedMonthName + ', ' + newDate[0]
  }
  acceptEntireQuote() {
    this.loader = true
    this.quoteDetailsData?.quoteLineDetails.forEach((element) => {
      if (element.quoteStatusCode === CurrentQuoteStatus.OPEN) {
        let lineItem = {
          brandCode: '',
          brandName: '',
          code: '',
          comment: '',
          csrResponseRequired: true,
          customerRequestedDate: '',
          isUnsolicited: true,
          productType: '',
          quantity: 0,
          listPrice: 0,
          quoteCartEntryType: '',
          quoteExtendedPrice: 0,
          quoteNetPrice: 0,
          reasonForQuote: '',
          rfqPartDescription: '',
          rfqPartNumber: '',
          serialNumber: '',
          tagNumber: '',
          itemNumber: '',
          netP: '',
          zumuPrice: '',
        }
        lineItem = {
          csrResponseRequired: true,
          brandCode: 'MASONEILAN',
          brandName: 'MASONEILAN',
          comment: element.additionalComments,
          customerRequestedDate: element.requestedShipDate.replace(/-/g, '/'),
          code: element.partNumber,
          isUnsolicited: true,
          productType: 'Part',
          quantity: Number(element.quantity),
          quoteExtendedPrice: Number(element.quoteExtendedPrice),
          quoteNetPrice: Number(element.quoteNetPrice),
          listPrice: Number(element?.listPrice),
          reasonForQuote: '',
          rfqPartDescription: element.partDescription,
          serialNumber: element.serialNumber,
          rfqPartNumber: element.partNumber,
          tagNumber: element.tagNumber,
          quoteCartEntryType: QuoteStatus.FULL,
          itemNumber: element.itemNumber,
          netP: element.netP,
          zumuPrice: element.zumuPrice,
        }
        this.lineItems.push(lineItem)
      }
    })

    var quoteObject = {
      billToAddress: this.billToAddress,
      deliveryAddress: this.shipToAddress,
      endUserAddress: this.endUserAddress,
      quoteCartType: QuoteStatus.FULL,
      quoteEntries: this.lineItems,
      quoteId: this.quoteId,
      contactNumber: null,
      customerProjectName:
        this.quoteDetailsData?.quoteDetailsList?.customerProjectName,
      endUserIndustry: this.quoteDetailsData?.quoteDetailsList?.endUserIndustry,
      notificationEmail:
        this.quoteDetailsData?.quoteDetailsList?.notificationEmail,
      customerReviewCheck: null,
      hasRestrictedUse: null,
      isNuclear: null,
      legalEntity: null,
      requiresExportLicense: null,
      restrictedCountryCheck: null,
      rfqType: this.quoteDetailsData?.quoteDetailsList?.rfqType,
      sanctionCheck: null,
    }
    this.AcceptQuote$ = this.quoteTrackingService.acceptQuote(quoteObject)
    this.AcceptQuote$.subscribe(
      (success) => {
        this.newCartId = success['code']
        this.multiCartService.loadCart({
          userId: this.userType,
          cartId: this.newCartId,
          extraData: {
            active: true,
          },
        })
        this.actions$
          .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
          .subscribe((success) => {
            this.loader = false
            this.router.navigate(['cart/checkout'])
          })
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'quoteTracking.ErrorPerformingAction2' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  openRejectPopUp() {
    const componentdata = {
      quoteId: this.quoteId,
    }

    const rejectQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.REJECT_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (rejectQuoteDialog) {
      rejectQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.REJECT_QUOTE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.reasonForRejection || value?.data?.comments) {
            this.rejectEntireQuote(value)
          }
        })
    }
  }

  rejectEntireQuote(value) {
    let rejectLineItems = []
    var i = 1
    this.quoteDetailsData?.quoteLineDetails.forEach((element) => {
      var obj = {
        itemNum: 0,
        rfqPartNumber: '',
        quoteRejectReason: '',
      }
      obj = {
        itemNum: i++,
        rfqPartNumber: element.partNumber,
        quoteRejectReason: value?.reasonForRejection,
      }
      rejectLineItems.push(obj)
    })
    let quoteData = {
      quoteCartType: QuoteStatus.REJECT,
      quoteId: this.quoteId,
      quoteEntries: rejectLineItems,
    }

    this.AcceptQuote$ = this.quoteTrackingService.rejectQuote(quoteData)
    this.AcceptQuote$.subscribe(
      (data) => {
        this.globalMessageService.add(
          { key: 'quoteTracking.quoteRejected' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          5000
        )
        this.router.navigate(['quote-detail', this.quoteId], {
          queryParams: this.dateObject,
        })
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'quoteTracking.errorPerforming' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
